import type { FeedItemType } from '@/types';

import { getImageParams } from './getImageParams';
import { getUrlForViewer } from './getUrlForViewer';
import { isImageForViewer } from './isImage';

export const getHrefForImageViewer = (result: FeedItemType) => {
  const { mime_type, object_location } = result;

  if (mime_type && isImageForViewer(mime_type.toLowerCase())) {
    const params = getImageParams(result);

    return getUrlForViewer('image', params);
  }

  return object_location;
};
